var AdaptiveImage = require("../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "src/assets/web/images/empty_state_followers.png",
    width: 2500,
    height: 1001
});